/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import can from 'can';
import DomEventsManager from 'scripts/dom-events-manager';
import deviceUtil from 'scripts/utils/device';

const scrollRightRailOffset = 50;

export const DepartmentResource = BaseControl.extend({
    $layout: null,
    $timeline: null,
    $rightRail: null,
    $window: null,
    layoutHeight: 0,
    layoutY: 0,
    timelineHeight: 0,
    rightRailHeight: 0,
    windowWidth: 0,
    windowHeight: 0,
    scrollY: 0,
    rightRailState: {
        isAtTop: false,
        isFixedAtTop: false,
        isFixedAtBottom: false,
        fixedOffset: 0
    },

    init: function () {
        this._super();
    },

});